import React, { useEffect } from 'react';


import SocialResponsibilitesBanner from './SocialResponsibilitesBanner';
import Socialresponsesectioncontetn from './Socialresponsesectioncontetn';
import SocailresponsibilitesAdvviser from './SocailresponsibilitesAdvviser';
import SocialServicessectionone from './SocialServicessectionone';
import SocialServicesanimatedcards from './SocialServicesanimatedcards';
import Socailresponsibilitesdocuments from './Socailresponsibilitesdocuments';
const Socialresponsebilites = () => {
          useEffect(() => {
            window.scrollTo(0, 0);
          }, []); // Empty dependency array ensures it only runs once when the component mounts
                  // Scroll to the top of the page when the component mounts
         
    return (
        <div style={{ backgroundColor: '#fff' }}>
  
            <SocialResponsibilitesBanner />
            <Socialresponsesectioncontetn />
            <SocailresponsibilitesAdvviser />
            <SocialServicessectionone />
            <SocialServicesanimatedcards />
            <Socailresponsibilitesdocuments />
      
        </div>
    );
};

export default Socialresponsebilites;
